var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .tick1 {\n        fill: #000000;\n      }\n\n      .tick2 {\n        fill: none;\n        stroke: #000000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 200px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tick1",
    d: "M1000,200c108.09,0,212.84,21.12,311.33,62.79,47.36,20.03,93.05,44.84,135.81,73.72,42.4,28.65,82.29,61.55,118.54,97.81,36.25,36.25,69.16,76.13,97.81,118.54,28.89,42.76,53.69,88.45,73.72,135.81,41.66,98.5,62.79,203.25,62.79,311.33s-21.12,212.84-62.79,311.33c-20.03,47.36-44.84,93.05-73.72,135.81-28.65,42.4-61.55,82.29-97.81,118.54-36.25,36.25-76.13,69.16-118.54,97.81-42.76,28.89-88.45,53.69-135.81,73.72-98.5,41.66-203.25,62.79-311.33,62.79s-212.84-21.12-311.33-62.79c-47.36-20.03-93.05-44.84-135.81-73.72-42.4-28.65-82.29-61.55-118.54-97.81-36.25-36.25-69.16-76.13-97.81-118.54-28.89-42.76-53.69-88.45-73.72-135.81-41.66-98.5-62.79-203.25-62.79-311.33s21.12-212.84,62.79-311.33c20.03-47.36,44.84-93.05,73.72-135.81,28.65-42.4,61.55-82.29,97.81-118.54,36.25-36.25,76.13-69.16,118.54-97.81,42.76-28.89,88.45-53.69,135.81-73.72,98.5-41.66,203.25-62.79,311.33-62.79M1000,0C447.72,0,0,447.72,0,1000s447.72,1000,1000,1000,1000-447.72,1000-1000S1552.28,0,1000,0h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "tick2",
    x1: 863.71,
    y1: 1345.56,
    x2: 532.26,
    y2: 1047.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "tick2",
    x1: 863.71,
    y1: 1345.56,
    x2: 1467.74,
    y2: 654.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick01);
export default __webpack_public_path__ + "static/media/Tick-01.86235ad8afb334fe6343151542fa4576.svg";
export { ForwardRef as ReactComponent };